var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10L4 10L4 8L6 8L6 10ZM4 2L2 2L2 4L5.24537e-07 4L3.49691e-07 6L2 6L2 8L4 8L4 6L21 6L21 4L4 4L4 2ZM4 2L4 -1.48619e-06L6 -1.31134e-06L6 2L4 2Z",
    fill: "#2B32EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackIcon);
export default __webpack_public_path__ + "static/media/go-back-icon.66fa748f9b9b659cc8b371e6b3716793.svg";
export { ForwardRef as ReactComponent };